import { Filters } from '@/types';

export namespace GlobalSearch {
  export enum Pages {
    SEARCH = 'search',

    GLOBAL_SEARCH_SLUG = 'global_search'
  }

  export interface SearchItems {
    [key: string]: unknown,
    content: string,
    page_slug: string,
    page_name: string,
    element_id: number,
  }

  export interface SearchPages {
    icon: string,
    name: string,
    slug: string,
  }
}

export interface SearchFilters extends Filters {
  page: string | null;
}
